import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BillingGuard } from './billing.guard';
import { ForceLogoutGuard } from './force-logout.guard';
import { LoginReturnGuard } from './login-return.guard';
import { LoginGuard } from './login.guard';
import { ManageDashboardsGuard } from './manageDashboards.guard';
import { ReloginGuard } from './relogin.guard';

@NgModule({
    imports: [RouterModule],
    providers: [
        BillingGuard,
        ForceLogoutGuard,
        LoginGuard,
        LoginReturnGuard,
        ReloginGuard,
        ManageDashboardsGuard
    ]
})
export class GuardModule {}
